import { render, staticRenderFns } from "./recoveryPasswordPage.vue?vue&type=template&id=a1797e6a&scoped=true&"
import script from "./recoveryPasswordPage.vue?vue&type=script&lang=js&"
export * from "./recoveryPasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1797e6a",
  null
  
)

export default component.exports